import { createSelector } from 'reselect';

const selectClosedAccounts = (state) => state.closedAccounts;
export const selectClosedAccountsData = (state) => selectClosedAccounts(state).data;
export const selectClosedAccountsTotal = (state) => selectClosedAccounts(state).total;
const selectLargeTransactions = (state) => state.largeTransactions;
export const selectLargeTransactionsData = (state) => selectLargeTransactions(state).data;
export const selectLargeTransactionsTotal = (state) => selectLargeTransactions(state).total;
const selectTimeLimitsReport = (state) => state.timeLimitsReport;
export const selectTimeLimitsReportData = (state) => selectTimeLimitsReport(state)?.report?.data;
export const selectTimeLimitsReportTotal = (state) => selectTimeLimitsReport(state)?.report?.total;
export const selectTimeLimitsReportTotals = (state) => selectTimeLimitsReport(state)?.totals;
export const selectLargeTransactionRecipients = (state) => state.largeTransactionRecipients;
const selectAmountLimitsReport = (state) => state.amountLimitsReport;
export const selectAmountLimitsReportData = (state) => selectAmountLimitsReport(state)?.report?.data;
export const selectAmountLimitsReportTotal = (state) => selectAmountLimitsReport(state)?.report?.total;
export const selectAmountLimitsReportTotals = (state) => selectAmountLimitsReport(state)?.totals;
const selectLargeTransactionsByBrand = (state) => state.largeTransactionsByBrand;
export const selectLargeTransactionsByBrandData = (state) => selectLargeTransactionsByBrand(state).data;
export const selectLargeTransactionsByBrandTotal = (state) => selectLargeTransactionsByBrand(state).total;
export const selectLargeTransactionsByBrandTotalData = (state) => selectLargeTransactionsByBrand(state).totalData;
const selectLargeTransactionsByPlayer = (state) => state.largeTransactionsByPlayer;
export const selectLargeTransactionsByPlayerData = (state) => selectLargeTransactionsByPlayer(state).data;
export const selectLargeTransactionsByPlayerTotal = (state) => selectLargeTransactionsByPlayer(state).total;
export const selectLargeTransactionsByPlayerTotalData = (state) => selectLargeTransactionsByPlayer(state).totalData;

const selectNegativeBalance = (state) => state.negativeBalance;
export const selectNegativeBalanceData = (state) => selectNegativeBalance(state).data;
export const selectNegativeBalanceTotal = (state) => selectNegativeBalance(state).total;

const selectLiabilityReport = (state) => state.liabilityReport;
export const selectLiabilityReportData = (state) => selectLiabilityReport(state)?.report?.data;
export const selectLiabilityReportTotal = (state) => selectLiabilityReport(state)?.report?.total;
export const selectLiabilityReportTotals = (state) => selectLiabilityReport(state)?.totals;

const selectBlockedPlayersReport = (state) => state.blockedPlayersReport;
export const selectBlockedPlayersReportData = (state) => selectBlockedPlayersReport(state)?.data;
export const selectBlockedPlayersReportTotal = (state) => selectBlockedPlayersReport(state)?.total;

const selectBiBetByPlayer = (state) => state.biBetByPlayer;
export const selectBiBetByPlayerData = (state) => selectBiBetByPlayer(state).report?.data;
export const selectBiBetByPlayerTotal = (state) => selectBiBetByPlayer(state).report?.total;
export const selectBiBetByPlayerTotals = (state) => selectBiBetByPlayer(state).totals;

const selectBiBetByCurrency = (state) => state.biBetByCurrency;
export const selectBiBetByCurrencyData = (state) => selectBiBetByCurrency(state).report?.data;
export const selectBiBetByCurrencyTotal = (state) => selectBiBetByCurrency(state).report?.total;
export const selectBiBetByCurrencyTotals = (state) => selectBiBetByCurrency(state).totals;

const selectBiFinancialByPlayer = (state) => state.biFinancialByPlayer;
export const selectBiFinancialByPlayerData = (state) => selectBiFinancialByPlayer(state).report?.data;
export const selectBiFinancialByPlayerTotal = (state) => selectBiFinancialByPlayer(state).report?.total;
export const selectBiFinancialByPlayerTotals = (state) => selectBiFinancialByPlayer(state).totals;

const selectBiFinancialByCurrency = (state) => state.biFinancialByCurrency;
export const selectBiFinancialByCurrencyData = (state) => selectBiFinancialByCurrency(state).report?.data;
export const selectBiFinancialByCurrencyTotal = (state) => selectBiFinancialByCurrency(state).report?.total;
export const selectBiFinancialByCurrencyTotals = (state) => selectBiFinancialByCurrency(state).totals;

const selectPlayersWallets = (state) => state.playersWallets;
export const selectPlayerWalletsData = (state) => selectPlayersWallets(state).data;
export const selectPlayerWalletsTotal = (state) => selectPlayersWallets(state).total;
const selectPlayersWalletsV2 = (state) => state.playersWalletsV2;
export const selectPlayerWalletsV2Data = (state) => selectPlayersWalletsV2(state).data;
export const selectPlayerWalletsV2Total = (state) => selectPlayersWalletsV2(state).total;
export const selectFinancialByProvider = (state) => state.financialByProvider;
export const selectProvidersTopNegativeGgrs = (state) => state.providersTopNegativeGgrs;
export const selectProviderTopNegativeGgrs = (state, id) => createSelector(
  () => selectProvidersTopNegativeGgrs(state),
  (data) => data[id] || null,
)();
export const selectProvidersTopPositiveGgrs = (state) => state.providersTopPositiveGgrs;
export const selectProviderTopPositiveGgrs = (state, id) => createSelector(
  () => selectProvidersTopPositiveGgrs(state),
  (data) => data[id] || null,
)();
const selectPlayersFirstDeposits = (state) => state.playersFirstDeposits;
export const selectPlayersFirstDepositsData = (state) => selectPlayersFirstDeposits(state).data;
export const selectPlayersFirstDepositsTotal = (state) => selectPlayersFirstDeposits(state).total;

const selectBonusTotalsByPlayer = (state) => state.bonusTotalsByPlayer;
export const selectBonusTotalsByPlayerData = (state) => selectBonusTotalsByPlayer(state)?.data;
export const selectBonusTotalsByPlayerTotal = (state) => selectBonusTotalsByPlayer(state)?.total;

const selectBonusTotalsByType = (state) => state.bonusTotalsByType;
export const selectBonusTotalsByTypeData = (state) => selectBonusTotalsByType(state)?.data;
export const selectBonusTotalsByTypeTotal = (state) => selectBonusTotalsByType(state)?.total;

const selectBonusTotalsByStatus = (state) => state.bonusTotalsByStatus;
export const selectBonusTotalsByStatusData = (state) => selectBonusTotalsByStatus(state)?.data;
export const selectBonusTotalsByStatusTotal = (state) => selectBonusTotalsByStatus(state)?.total;

const selectBonusTotalsByProvider = (state) => state.bonusTotalsByProvider;
export const selectBonusTotalsByProviderData = (state) => selectBonusTotalsByProvider(state)?.data;
export const selectBonusTotalsByProviderTotal = (state) => selectBonusTotalsByProvider(state)?.total;

const selectInactivePlayers = (state) => state.inactivePlayers;
export const selectInactivePlayersData = (state) => selectInactivePlayers(state).data;
export const selectInactivePlayersTotal = (state) => selectInactivePlayers(state).total;

export const selectTopPlayersByGgr = (state) => state.topPlayersByGgr;

export const selectTopPlayersByGgrDetails = (state) => state.topPlayersByGgrDetails;
export const selectTopPlayerByGgrDetails = (state, playerId) => createSelector(
  () => selectTopPlayersByGgrDetails(state),
  (data) => data[playerId],
)();

export const selectTopPlayersByTransactionType = (state) => state.topPlayersByTransactionType;

export const selectTopPlayersByTransactionTypeDetails = (state) => state.topPlayersByTransactionTypeDetails;
export const selectTopPlayerByTransactionTypeDetails = (state, playerId) => createSelector(
  () => selectTopPlayersByTransactionTypeDetails(state),
  (data) => data[playerId],
)();

const selectTaxation = (state) => state.taxation;
export const selectTaxationData = (state) => selectTaxation(state).report?.data;
export const selectTaxationTotal = (state) => selectTaxation(state).report?.total;
export const selectTaxationTotals = (state) => selectTaxation(state).totals;

const selectBrandsWallets = (state) => state.brandsWallets;
export const selectBrandsWalletsData = (state) => selectBrandsWallets(state)?.data;
export const selectBrandsWalletsTotals = (state) => selectBrandsWallets(state)?.totals;

const selectBiPeriodicReportByPlayer = (state) => state.biPeriodicReportByPlayer;
export const selectBiPeriodicReportDataByPlayer = (state) => selectBiPeriodicReportByPlayer(state).report?.data;
export const selectBiPeriodicReportTotalByPlayer = (state) => selectBiPeriodicReportByPlayer(state).report?.total;
export const selectBiPeriodicReportTotalsByPlayer = (state) => selectBiPeriodicReportByPlayer(state)?.totals;

const selectTaxationStatisticsByPlayer = (state) => state.taxationStatisticsByPlayer;
export const selectTaxationStatisticsByPlayerData = (state) => selectTaxationStatisticsByPlayer(state).report?.data;
export const selectTaxationStatisticsByPlayerTotal = (state) => selectTaxationStatisticsByPlayer(state).report?.total;
export const selectTaxationStatisticsByPlayerTotals = (state) => selectTaxationStatisticsByPlayer(state).totals;

const selectTaxationByCategory = (state) => state.taxationByCategory;
export const selectTaxationByCategoryData = (state) => selectTaxationByCategory(state).report?.data;
export const selectTaxationByCategoryTotal = (state) => selectTaxationByCategory(state).report?.total;
export const selectTaxationByCategoryTotals = (state) => selectTaxationByCategory(state).totals;

const selectTaxationStatisticsByCategory = (state) => state.taxationStatisticsByCategory;
export const selectTaxationStatisticsByCategoryData = (state) => selectTaxationStatisticsByCategory(state).report?.data;
export const selectTaxationStatisticsByCategoryTotal = (state) => selectTaxationStatisticsByCategory(state).report?.total;
export const selectTaxationStatisticsByCategoryTotals = (state) => selectTaxationStatisticsByCategory(state).totals;
